// League-row helpers. The league array is positional (docs/ODDS_SPECS.md), so anything
// that interprets a field by index belongs here rather than at each call site.

export default {
  // The league kind carried in item[10]: "virtual", "major", or "normal".
  //
  // This exists for one reason: NORMAL IS THREE DISTINCT WIRE VALUES — "", null, and the
  // element being absent entirely. `row[10] !== "virtual"` reads as the natural test and
  // silently misclassifies whichever of the three a given feed happens to send, in the
  // cases nobody writes a fixture for. Testing for the positive values and defaulting to
  // normal cannot go wrong that way.
  //
  // An unrecognised value also falls to "normal", deliberately: a league kind this build
  // predates should still be listed rather than hidden. Hiding on an unknown value is how
  // a backend addition empties a filter for everyone on an older bundle.
  kind(row) {
    const value = row == null ? null : row[10];
    if (value === "virtual") return "virtual";
    if (value === "major") return "major";
    return "normal";
  },

  // Class for a league kind, or "" so a normal league keeps the stock header.
  // Mobile CSS keys off .bg-normal-head.virtual (odds.css, color5.css), on the header itself.
  kindClass(kind) {
    if (kind === "virtual") return "virtual";
    if (kind === "major") return "";
    return "";
  }
};
